package org.solyton.solawi.bid.module.application.`data`.management

import kotlin.Int
import kotlin.collections.List
import org.evoleq.axioms.definition.ReadOnly
import org.evoleq.axioms.definition.ReadWrite
import org.evoleq.compose.modal.Modals
import org.evoleq.device.`data`.Device
import org.evoleq.optics.lens.Lens
import org.evoleq.optics.storage.ActionDispatcher
import org.solyton.solawi.bid.module.application.`data`.application.Application
import org.solyton.solawi.bid.module.application.`data`.organizationrelation.ApplicationOrganizationRelation
import org.solyton.solawi.bid.module.application.`data`.userapplication.UserApplications
import org.solyton.solawi.bid.module.i18n.`data`.Environment
import org.solyton.solawi.bid.module.i18n.`data`.I18N
import org.solyton.solawi.bid.module.permissions.`data`.Permissions
import org.solyton.solawi.bid.module.permissions.`data`.relations.ContextRelation

/**
 * Autogenerated ReadOnly Lens.
 * Read [ApplicationManagement.actions]
 */
@ReadOnly
public val actions: Lens<ApplicationManagement, ActionDispatcher<ApplicationManagement>> by lazy {
      Lens(
        get = { whole -> whole.actions },
        set = { { it } }
      )}


/**
 * Autogenerated ReadOnly Lens.
 * Read [ApplicationManagement.deviceData]
 */
@ReadOnly
public val deviceData: Lens<ApplicationManagement, Device> by lazy {
      Lens(
        get = { whole -> whole.deviceData },
        set = { { it } }
      )}


/**
 * Autogenerated ReadOnly Lens.
 * Read [ApplicationManagement.environment]
 */
@ReadOnly
public val environment: Lens<ApplicationManagement, Environment> by lazy {
      Lens(
        get = { whole -> whole.environment },
        set = { { it } }
      )}


/**
 * Autogenerated Lens.
 * Read and manipulate [ApplicationManagement.modals]
 */
@ReadWrite
public val modals: Lens<ApplicationManagement, Modals<Int>> by lazy {
      Lens(
        get = { whole -> whole.modals },
        set = { part -> { whole -> whole.copy(modals = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [ApplicationManagement.modals]
 */
@ReadWrite
public fun ApplicationManagement.modals(`set`: Modals<Int>.() -> Modals<Int>): ApplicationManagement
    = copy(modals = set(modals))

/**
 * Autogenerated Lens.
 * Read and manipulate [ApplicationManagement.i18n]
 */
@ReadWrite
public val i18n: Lens<ApplicationManagement, I18N> by lazy {
      Lens(
        get = { whole -> whole.i18n },
        set = { part -> { whole -> whole.copy(i18n = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [ApplicationManagement.i18n]
 */
@ReadWrite
public fun ApplicationManagement.i18n(`set`: I18N.() -> I18N): ApplicationManagement = copy(i18n =
    set(i18n))

/**
 * Autogenerated Lens.
 * Read and manipulate [ApplicationManagement.availableApplications]
 */
@ReadWrite
public val availableApplications: Lens<ApplicationManagement, List<Application>> by lazy {
      Lens(
        get = { whole -> whole.availableApplications },
        set = { part -> { whole -> whole.copy(availableApplications = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [ApplicationManagement.availableApplications]
 */
@ReadWrite
public
    fun ApplicationManagement.availableApplications(`set`: List<Application>.() -> List<Application>):
    ApplicationManagement = copy(availableApplications = set(availableApplications))

/**
 * Autogenerated Lens.
 * Read and manipulate [ApplicationManagement.availablePermissions]
 */
@ReadWrite
public val availablePermissions: Lens<ApplicationManagement, Permissions> by lazy {
      Lens(
        get = { whole -> whole.availablePermissions },
        set = { part -> { whole -> whole.copy(availablePermissions = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [ApplicationManagement.availablePermissions]
 */
@ReadWrite
public fun ApplicationManagement.availablePermissions(`set`: Permissions.() -> Permissions):
    ApplicationManagement = copy(availablePermissions = set(availablePermissions))

/**
 * Autogenerated Lens.
 * Read and manipulate [ApplicationManagement.personalApplications]
 */
@ReadWrite
public val personalApplications: Lens<ApplicationManagement, List<Application>> by lazy {
      Lens(
        get = { whole -> whole.personalApplications },
        set = { part -> { whole -> whole.copy(personalApplications = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [ApplicationManagement.personalApplications]
 */
@ReadWrite
public
    fun ApplicationManagement.personalApplications(`set`: List<Application>.() -> List<Application>):
    ApplicationManagement = copy(personalApplications = set(personalApplications))

/**
 * Autogenerated Lens.
 * Read and manipulate [ApplicationManagement.personalApplicationContextRelations]
 */
@ReadWrite
public val personalApplicationContextRelations: Lens<ApplicationManagement, List<ContextRelation>>
    by lazy {
      Lens(
        get = { whole -> whole.personalApplicationContextRelations },
        set = { part -> { whole -> whole.copy(personalApplicationContextRelations = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [ApplicationManagement.personalApplicationContextRelations]
 */
@ReadWrite
public
    fun ApplicationManagement.personalApplicationContextRelations(`set`: List<ContextRelation>.() -> List<ContextRelation>):
    ApplicationManagement = copy(personalApplicationContextRelations =
    set(personalApplicationContextRelations))

/**
 * Autogenerated Lens.
 * Read and manipulate [ApplicationManagement.personalModuleContextRelations]
 */
@ReadWrite
public val personalModuleContextRelations: Lens<ApplicationManagement, List<ContextRelation>> by
    lazy {
      Lens(
        get = { whole -> whole.personalModuleContextRelations },
        set = { part -> { whole -> whole.copy(personalModuleContextRelations = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [ApplicationManagement.personalModuleContextRelations]
 */
@ReadWrite
public
    fun ApplicationManagement.personalModuleContextRelations(`set`: List<ContextRelation>.() -> List<ContextRelation>):
    ApplicationManagement = copy(personalModuleContextRelations =
    set(personalModuleContextRelations))

/**
 * Autogenerated Lens.
 * Read and manipulate [ApplicationManagement.userApplications]
 */
@ReadWrite
public val userApplications: Lens<ApplicationManagement, List<UserApplications>> by lazy {
      Lens(
        get = { whole -> whole.userApplications },
        set = { part -> { whole -> whole.copy(userApplications = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [ApplicationManagement.userApplications]
 */
@ReadWrite
public
    fun ApplicationManagement.userApplications(`set`: List<UserApplications>.() -> List<UserApplications>):
    ApplicationManagement = copy(userApplications = set(userApplications))

/**
 * Autogenerated Lens.
 * Read and manipulate [ApplicationManagement.applicationOrganizationRelations]
 */
@ReadWrite
public val applicationOrganizationRelations:
    Lens<ApplicationManagement, List<ApplicationOrganizationRelation>> by lazy {
      Lens(
        get = { whole -> whole.applicationOrganizationRelations },
        set = { part -> { whole -> whole.copy(applicationOrganizationRelations = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [ApplicationManagement.applicationOrganizationRelations]
 */
@ReadWrite
public
    fun ApplicationManagement.applicationOrganizationRelations(`set`: List<ApplicationOrganizationRelation>.() -> List<ApplicationOrganizationRelation>):
    ApplicationManagement = copy(applicationOrganizationRelations =
    set(applicationOrganizationRelations))
